export default __webpack_public_path__ + "static/media/(23).59f5ce70.JPG";